/* unplugin-vue-components disabled */import script from "./index.vue?vue&type=script&setup=true&name=JessibucaPro&lang=js"
export * from "./index.vue?vue&type=script&setup=true&name=JessibucaPro&lang=js"

import "./index.vue?vue&type=style&index=0&id=4239d97c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4239d97c"]])

export default __exports__